import { useEffect, useState } from 'react';
import { notification, Button, Checkbox, Form, Modal, Slider } from 'antd';
import moment from 'moment-timezone';
import ApiService from '../../../services/ApiService';
import { VCRow } from './styles';

const initialYear = {
  isFERandom: true,
  feProbability: 0,
  isDERandom: true,
  deProbability: 0,
};

const buildYearPayload = formData => {
  const now = moment.utc();
  return {
    StartsOn: now.format('M/D/YYYY H:m:s'),
    EndsOn: now.clone().add(1, 'year').format('M/D/YYYY H:m:s'),
    MaximumTransactions: 0,
    GoalWeightingType: 1,
    FortuitousEventsRandomAndInvisible: formData.isFERandom,
    FortuitousEventsProbability: formData.isFERandom ? 0 : formData.feProbability / 100,
    DisastrousEventsRandomAndInvisible: formData.isDERandom,
    DisastrousEventsProbability: formData.isDERandom ? 0 : formData.deProbability / 100,
    MilitaryEventsRandomAndInvisible: false,
    MilitaryEventsProbability: 0,
  };
};

export const SimulationYearModal = ({ simulationId, years, year, onClose, onSave }) => {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [isSubmitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({ ...initialYear });

  const handleFormValueChange = field => e => {
    if (['isFERandom', 'isDERandom'].includes(field)) {
      setFormData({
        ...formData,
        [field]: e.target.checked,
      });
    } else {
      setFormData({
        ...formData,
        [field]: e,
      });
    }
  };

  const onFinish = async () => {
    setSubmitting(true);
    try {
      if (!year?.Year) {
        const updatedYears = [...years, buildYearPayload(formData)];
        updatedYears.forEach(y => {
          delete y.Year;
        });
        await ApiService.updateSimulationYears(simulationId, {
          simulationYearArrayStringified: JSON.stringify(updatedYears),
        });
      } else {
        const index = years.findIndex(y => y.Year === year.Year);
        const updatedYear = {
          ...years[index],
          ...buildYearPayload(formData),
        };
        const updatedYears = [...years];
        updatedYears[index] = updatedYear;
        updatedYears.forEach(y => {
          delete y.Year;
        });
        await ApiService.updateSimulationYears(simulationId, {
          simulationYearArrayStringified: JSON.stringify(updatedYears),
        });
      }
      onSave();
    } catch (e) {
      api.open({
        message: 'Sorry...',
        description: 'Something went wrong...',
      });
    }
    setSubmitting(false);
  };

  useEffect(() => {
    form.resetFields();
    if (year?.Year) {
      setFormData({
        isFERandom: year.FortuitousEventsRandomAndInvisible,
        feProbability: Math.round(year.FortuitousEventsProbability * 100),
        isDERandom: year.DisastrousEventsRandomAndInvisible,
        deProbability: Math.round(year.DisastrousEventsProbability * 100),
      });
    } else {
      setFormData({ ...initialYear });
    }
  }, [form, year]);

  return (
    <Modal
      title={year?.Year ? `Edit Year ${year.Year} Events` : 'Add Year Events'}
      open={!!year}
      onCancel={onClose}
      footer={[
        <Button key="save" type="primary" loading={isSubmitting} onClick={() => form.submit()}>
          {!year?.Year ? 'Add' : 'Save'}
        </Button>,
      ]}
    >
      {contextHolder}
      <Form layout="vertical" form={form} onFinish={onFinish} requiredMark={false} autoComplete="off">
        <Form.Item label="Fortuitous Events">
          <VCRow>
            <Checkbox checked={formData.isFERandom} onChange={handleFormValueChange('isFERandom')}>
              Randomize
            </Checkbox>
            <Slider
              value={formData.feProbability}
              onChange={handleFormValueChange('feProbability')}
              disabled={formData.isFERandom}
            />
            <label>{formData.feProbability}%</label>
          </VCRow>
        </Form.Item>
        <Form.Item label="Disastrous Events">
          <VCRow>
            <Checkbox checked={formData.isDERandom} onChange={handleFormValueChange('isDERandom')}>
              Randomize
            </Checkbox>
            <Slider
              value={formData.deProbability}
              onChange={handleFormValueChange('deProbability')}
              disabled={formData.isDERandom}
            />
            <label>{formData.deProbability}%</label>
          </VCRow>
        </Form.Item>
        <Form.Item className="d-none">
          <Button type="primary" htmlType="submit"></Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
